<template>
  <div
    class="flex min-h-screen flex-col text-primary antialiased anchor-scrolling-none"
  >
    <header
      class="relative flex h-15 items-center justify-between border-b px-7 text-md font-medium text-gray-900"
    >
      <SFLocalizedLink
        :to="routeList.home"
        class="flex items-center gap-2 rounded-md p-1 text-md font-medium text-primary hover:bg-gray-100"
        raw
      >
        <IconBack class="size-3" />
        <div class="mr-auto hidden pt-0.5 md:block">
          {{ $t('global.back_to_shop') }}
        </div>
        <div class="mr-auto block pt-0.5 md:hidden">
          {{ $t('global.to_shop') }}
        </div>
      </SFLocalizedLink>

      <SFLocalizedLink
        :aria-label="shopName"
        :to="routeList.home"
        class="absolute left-1/2 -translate-x-1/2"
        raw
      >
        <IconLogo aria-hidden="true" class="w-[80px] md:w-[100px]" />
      </SFLocalizedLink>

      <nav class="hidden flex-row gap-4 md:flex">
        <SFNavigationTreeItem
          v-for="navItem in headerTree?.items"
          :key="`footer-link-${navItem.id}`"
          :navigation-item="navItem"
          class="rounded-md p-1 hover:bg-gray-100"
          raw
        />
        <span class="ml-auto" />
      </nav>
    </header>
    <main class="grow">
      <NuxtPage />
    </main>
    <footer class="flex flex-col gap-4 border-t">
      <SFBottomFooter :show-copyright="false" />
    </footer>
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '#imports'
import SFLocalizedLink from '~/components/SFLocalizedLink.vue'
import { useNuxtApp } from '#app/nuxt'
import { useCurrentShop } from '#storefront/composables'
import { useSimpleHeaderNavigation } from '#storefront-navigation/composables'
import { NuxtPage } from '#components'
import SFNavigationTreeItem from '~/components/SFNavigationTreeItem.vue'
import { routeList } from '~/utils/route'
import SFBottomFooter from '~/components/SFBottomFooter.vue'

const currentShop = useCurrentShop()

const { data: headerTree } = useSimpleHeaderNavigation()

const {
  $config: {
    public: { shopName },
  },
} = useNuxtApp()

// Meta tags
useHead({
  bodyAttrs: {
    class: ['relative'],
  },
  htmlAttrs: {
    lang: () => new Intl.Locale(currentShop.value.locale).language,
  },
  script: [
    {
      // Add loaded class to body after DOMContentLoaded
      innerHTML: `document.addEventListener('DOMContentLoaded', () => { document.body.classList.add('loaded'); });`,
    },
  ],
  titleTemplate: (title) => (title ? `${title} | ${shopName}` : `${shopName}`),
})
defineOptions({ name: 'AppSimple' })
</script>
